export enum UserEventTypes {
  /* listing views */
  DASHBOARD_VIEW = 'dashboard_view',
  LISTING_VIEW = 'listing_view',
  LISTINGS_TRENDING_CLICK_THROUGH = 'listings_trending_click_through',
  LISTINGS_NEW_CLICK_THROUGH = 'listings_new_click_through',
  LISTINGS_NO_TAG_CLICK_THROUGH = 'listings_no_tag_click_through',

  /* Payment event types */
  PAY_WITH_SLOPE_BUTTON_CLICK = 'pay_with_slope_button_click',
  PAY_WITH_SLOPE_BUTTON_SUCCESS = 'pay_with_slope_button_success',
  PAY_WITH_SLOPE_BUTTON_CLOSE = 'pay_with_slope_button_close',
  PAY_WITH_SLOPE_BUTTON_ERROR = 'pay_with_slope_button_error',

  /* favorites heart types */
  HEART_CLICK_TO_FAVORITE = 'heart_click_to_favorite',
  HEART_CLICK_TO_UNFAVORITE = 'heart_click_to_unfavorite',

  // Offers-2.0
  DELETE_OFFER_CLICKED = 'delete_offer_clicked',
  LDP_ADD_ALL_STYLES_TO_OFFER_CLICK = 'ldp_add_all_styles_to_offer_click',
  LDP_PRODUCT_CLICKED = 'ldp_product_clicked',
  LOW_BALL_OFFER_SUBMITTED = 'low_ball_offer_submitted',
  OFFER_ADD_MORE_ITEMS_CLICKED = 'offer_add_more_items_clicked',
  OFFER_ADD_PRODUCT_ICON_CLICKED = 'offer_add_product_icon_clicked',
  OFFER_CONFIRMATION_SUBMIT_CLICKED = 'offer_confirmation_submit_clicked',
  OFFER_DELETE_ONE_PRODUCT_CLICKED = 'offer_delete_one_product_clicked',
  OFFER_REMOVE_PRODUCT_ICON_CLICKED = 'offer_remove_product_icon_clicked',
  OFFER_UNDO_PRODUCT_DELETION_CLICKED = 'offer_undo_product_deletion_clicked',
  PDP_ADD_TO_OFFER_CLICKED = 'pdp_add_to_offer_clicked',
}
